// Components
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

type NavbarTextButtonType = {
  dataTestId: string;
  title: string;
  onClick: () => void;
  isUnderlined: boolean;
  showTab: boolean;
};

const NavbarTextButton = ({
  dataTestId,
  title,
  onClick,
  isUnderlined,
  showTab,
}: NavbarTextButtonType) => {
  if (!showTab) {
    return null;
  }

  return (
    <Button
      data-testid={dataTestId}
      key={`navbar-text-button-${title}`}
      onClick={onClick}
      sx={{ minWidth: 0 }}
    >
      <Box
        sx={{
          color: "#FFF",
          textTransform: "capitalize",
          fontSize: "16px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          width: "fit-content",
          minWidth: 0,
          borderBottom: "2px solid transparent",

          ...(isUnderlined && {
            fontWeight: "bold",
            borderBottom: "2px solid #E2772E",
            borderRadius: 0,
          }),
        }}
      >
        {title}
      </Box>
    </Button>
  );
};

export default NavbarTextButton;
